module.exports = __webpack_public_path__ + "static/media/19-14.cbaa65f8.mp3";